var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12 itemNameInner 1" }, [
    _c("p", { staticClass: "h1" }, [
      _vm._v("      \n    " + _vm._s(_vm.varitemname) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }